import React from 'react';
import ReactTooltip from 'react-tooltip';

import { themeIcon } from './themeIcon';
import styles from './styles.module.scss';

interface Props {
  className?: string;
  type?: string;
  infrastructure: {
    id: number;
    name: string;
    nameEs?: string;
  };
  imgClass?: string;
  textClass?: string;
  dark?: boolean;
  compact?: boolean;
  shareUrl?: string;
  shareVerticalPosition?: boolean;
  isCard?: boolean;
}

function ContentType({ className, type, infrastructure, dark, compact, imgClass, textClass, shareUrl, shareVerticalPosition, isCard }: Props) {
  const descriptionClassName =  dark ? styles.descriptionDark : styles.descriptionWhite;

  const infArray = Array.isArray(infrastructure);
  const singleInf = !infArray || infrastructure.length == 1;

  const showText = singleInf || !isCard;

  function renderInfrastructure(inf) {
    return (
      <>
        { !showText && (
          <img alt="" src={themeIcon(inf)} data-tip={inf.name} className={`m-right-1 ${imgClass}`} />
        )}

        { showText && (
          <img alt="" src={themeIcon(inf)} className={`m-right-1 ${imgClass}`} />
        )}
        
        { showText && (
          <span className={`${textClass}`}>
            {inf.name}
          </span>
        )}
      </>
    );
  }

  return (
    <div className={`middle ${styles.description} ${descriptionClassName} ${compact ? styles.compact : ''} ${className}`}>
      
      {infrastructure && !infArray && (
        renderInfrastructure(infrastructure)
      )}
      <ReactTooltip />
    </div>
  );
}

export default ContentType;
